import Env_Config from './settings'

export const url = {
  backendHost: Env_Config.api.url,
}

export const endPoint = {
}
